import React from 'react';

import ewAnalytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';
import { FluidImageType } from 'utils/types';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { size } from '@everlywell/leaves';

import * as S from './styles';

type ImageType = {
  fluid: FluidImageType;
  description: string;
};

export type PromoProps = {
  slug: string;
  content: string;
  image: ImageType & IGatsbyImageData;
  active: boolean;
  link: any;
  row: number;
  column: number;
  span: number;
};

const styles = { borderRadius: `${size.xs3}px` };

export const PromoCard: React.FC<PromoProps> = ({
  slug,
  image,
  content,
  link,
  active,
  row,
  column,
  span,
}) => {
  if (!active) return null;

  const handlePromoClick = () => {
    ewAnalytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: slug || 'PIP Promo Unit',
      },
    });
  };

  const gImage = getImage(image) as IGatsbyImageData;

  return (
    <S.PromoWrapper href={link} row={row} column={column} span={span}>
      <S.ImageWrapper>
        <GatsbyImage
          image={gImage}
          imgStyle={styles}
          alt={image.description}
          loading="eager"
        />
      </S.ImageWrapper>
      <S.ContentWrapper>
        <S.PromoContent>{content}</S.PromoContent>
        <S.PromoButton
          href={link}
          appearance="primary"
          hasArrow={true}
          onClick={handlePromoClick}
        >
          Learn More
        </S.PromoButton>
      </S.ContentWrapper>
    </S.PromoWrapper>
  );
};
